import { Injectable, Inject } from '@angular/core';
import { UserManager, User, OidcMetadata, OidcClientSettings } from 'oidc-client';
import { ReplaySubject } from 'rxjs';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { forEach } from '@angular/router/src/utils/collection';
import * as _config from '../config';
import * as _entityManagerProvider from '../entitymanagerprovider';

@Injectable({
    providedIn: 'root'
})
export class OpenIdConnectService {
    private settings: OidcClientSettings = {
        authority: "https://login.microsoftonline.com/6e57fc1a-413e-4050-91da-7d2dc8543e3c/",
        metadataUrl: _config.configApi + '/.well-known/openid-configuration',
        client_id: "c1bdffe5-3e73-4347-8182-fcd04f8a8990",
        redirect_uri: _config.virtualDirRoot + "signin-oidc",
        scope: "openid",
        response_type: "id_token"
    }

    private userManager: UserManager = new UserManager(this.settings);
    private currentUser: User;
    redirectKey = "redirect";

    userLoaded$ = new ReplaySubject<boolean>(1);

    get userAvailable(): boolean {
        return this.currentUser != null;
    }

    get user(): User {
        return this.currentUser;
    }

    get profile(): any {
        if (this.userAvailable) {
            return this.currentUser.profile;
        }

        return null;
    }

    get internal(): boolean {
        return this.userAvailable
            && this.profile.amr
            && this.profile.amr[0] == "wia";
    }

    constructor(private http: HttpClient) {
        this.userManager.clearStaleState();

        this.userManager.events.addUserLoaded(user => {
            if (!environment.production) {
                console.log('User Loaded', user);
            }

            this.currentUser = user;

            _entityManagerProvider
                .init(this.http)
                .then(this.loadUserData.bind(this))
                .then(() => {
                    this.userLoaded$.next(true);
                })
        });

        this.userManager.events.addUserUnloaded(() => {
            if (!environment.production) {
                console.log('User unloaded');
            }

            this.currentUser = null;
            this.userLoaded$.next(false);
        });
    }

    loadUserData() {
        return this.http.get<any>(`${_config.serviceName}/getUserData`)
            .toPromise()
            .then((data) => {
                if (data) {
                    Object.keys(data).forEach(key => {
                        if (data.hasOwnProperty(key)) {
                            this.currentUser.profile[key] = data[key];
                        }
                    });
                }

                return true;
            })
            .catch(err => {
                Promise.reject(err);
            });
    }

    triggerSignIn(path?: string) {
        this.userManager.signinRedirect().then(function () {
            if (!environment.production) {
                console.log('Redirection to signin triggered.');
            }
        });
    }

    handleCallback() {
        this.userManager.signinRedirectCallback().then(function (user) {
            if (!environment.production) {
                console.log('Callback after signin handled.', user);
            }
        });
    }

    handleSilentCallback() {
        this.userManager.signinSilentCallback().then(function (user) {
            this.currentUser = user
            if (!environment.production) {
                console.log('Callback after silent signin handled.', user);
            }
        });
    }

    triggerSignOut() {
        this.userManager.signoutRedirect().then(function (resp) {
            if (!environment.production) {
                console.log('Redirection to sign out triggered.', resp);
            }
        });
    };
}
